const Messages = {
  Success: {
    Saved: 'Збережено',
    Rejected: 'Скасовано',
    PasswordChanged: 'Пароль успішно змінено',
    ActivationSuccessful: 'Активація завершилася успішно',
    CheckYourEmailToCompleteReg: 'Підтвердіть ваш email для завершення реєстрації',
    Copied: 'Фільтр успішно скопійовано',
    NotCopiedFilterNotSet: 'Не скопійовано. Фільтр не встановлений',
    DocumentsPassed: 'Документи проведені',
    DocumentsUnpassed: 'Проведення документів скасовано',
  },

  Errors: {
    PageSize: '`pageSize` має бути позитивним цілим числом більше за нуль',
    ErrorWhileRequest: 'Сталася помилка під час отримання даних. {0}',
    ErrorWhileRequestTotal: 'Сталася помилка під час отримання даних підсумкового рядка. {0}',
    FormNotFound: 'Форма {0} не знайдена',
    UnsupportedFieldType: 'Непідтримуваний тип поля - {0}',
    FieldIsRequired: "Поле {0} обов'язкове",
    FilterNotSet: 'Фільтр не встановлений',
    FilteringRulesError: 'Filtering rules are not defined!',
    CopingRulesError: 'Coping rules are not defined!',
    FieldsAreRequired: "Поля обов'язкові до заповнення: {0}",
    LoginValidMsg: 'Поле не повинно бути порожнім або містити пробіли.',
    PassValidMsg: 'Поле не повинно бути порожнім або містити менше 6 символів.',
    CustomFontsLoadingError: 'Не вдалося завантажити призначені для користувача шрифти',
    RequiredFiltersEmpty: "Обов'язкові фільтри не заповнені",
    FiltersAreRequired: "Обов'язкові фільтри до заповнення: {0}",
    SmallPassword: 'Ваш пароль повинен бути більше {0} знаків',
    IsEmptyBodyFilter: 'Ви намагаєтеся зберегти порожній фільтр',
    RecordNotFound: 'Записи не знайдені.',
    EmailIsRequired: 'Поле email не може залишатися порожнім',
    PassAndConfirmDifferent: 'Паролі не співпадають',
    PassAndConfirmRequired: "Поля password і confirmation обов'язкові",
    PassRequired: 'Поле password повинно бути заповнено',
    ConfirmRequired: 'Необхідно підтвердити пароль',
    ResponseEmpty: 'Response is empty.',
    AtLeastOneRowMustBeSelected: 'Виберіть хоча б один рядок',
    FilteringRulesAreNotDefined: 'Правила фільтрації не визначені',
    OnlyOneSelectedRowAllowedForThisAction: 'Для даної операції повинен бути обраний тільки один рядок',
    ListFormAndTreeViewSubFormsTypes:
      'Тільки сабформи типу `ListForm`, `TreeView`, `EditForm` и `FreeForm` дозволені для форм типу `ListForm` та `TreeView`',
    EditFormAndFreeFormSubFormsTypes:
      'Тільки сабформи типу `ListForm`, `TreeView`, `EditForm` и `FreeForm`  дозволені для форм типу `EditForm` та `FreeForm`',
    ReportFormAndMultiEditFormSubFormsTypes: 'Сабформи для форм типу `ReportForm` та `GroupEditForm` не дозволені',
    EmptyRespInGetEditFormDataFunc: 'Empty response in getEditFormData function',
    IsRequired: 'не заповнено',
    AreRequired: 'не заповнені',
    SpacesError: 'не може містити пробіл',
    IsIncorrect: 'невірне',
    ErrorSymbols: 'Неприпустимі символи в полі {0}',
    NoFormAttached: 'Для даної операції немає закріпленої форми',
    InvalidDate: 'Не вірний формат дати',
    DateToMustBeLess: 'Дата кінця повинна бути меншою за дату початку',
    WhileDeletingRow: 'Помилка при видаленні рядків',
    AtLeastOneTabMustBeVisible: 'Повинна бути видима хоча б одна закладка',
    AtLeastOneButtonMustBeVisibleInToolbar: 'Повинна бути видима хоча б одна кнопка в тулбарі',
    AtLeastOneButtonMustBeVisibleInMenu: 'Повинна бути видима хоча б одна кнопка в меню',
    AtLeastOneColumnMustBeVisible: 'Повинна бути видима хоча б одна колонка',
    AtLeastOneBoardMustBeVisible: 'Повинна бути видима хоча б одна дошка',
    InvalidDateEntered: 'Не вірно введена дата.',
    ErrorOccurred: 'Виникла помилка',
    InvalidFilter: 'Збережений фільтр є некоректним. Будь ласка, перестворіть його.',
    ClientScriptInitializationError: 'Помилка ініціалізації клієнтського скріпта',
    ParentFormError: 'Може викликатися лише на батьківській формі, але не на сабформі.',
    GroupDoesNotExist: 'Цієї групи {0} не існує',
    ButtonDoesNotExist: 'Кнопки {0} не існує',
  },

  Warning: {
    ChangeFilterInUserScript:
      'У користувальницьких скриптах заборонено змінювати ' +
      'фільтр поки таблиця знаходиться в режимі редагування. Фільтр не застосувався.',
    CustomParamByFN: 'Поле `{0}`, вказане в `CustomParameters`, не знайдено на формі.',
    EditNestedDataOnlyInInlineMode: "Редагування вкладених об'єктів можливо тільки в рядку.",
    OnSaveRowDeprecated: 'Метод `onSaveRow` застарів, використовуйте `onRowBeforeSave` натомість.',
    OnInitializedDeprecated: 'Метод `onInitialized` застарів, використовуйте `onBeforeEditRow` натомість.',
    OnMasterSelectFilterDeprecated:
      'Метод `OnMasterSelectFilter` застарів, використовуйте `onMasterSelectFilter` натомість.',
    OnBeforeGetDataFilterDeprecated: 'Метод `OnBeforeGetData` застарів, використовуйте `onBeforeGetData` натомість.',
    AllColumnsDisabledForReordering: 'Зміна порядку колонок заборонена.',
    LoadAllWarningMessage: 'Відображено перші `{0}` рядків. Уточніть умову відбору даних',
    FormWithoutElements: 'Неможливо відкрити форму без елементів',
  },

  Confirm: {
    RowsDelete: 'Видалити вибрані елементи?',
    SaveChanges: 'Зберегти внесені зміни?',
    ResetAllSettings: 'Ви впевнені, що хочете скинути всі налаштування?',
    ClearQuickFilters: 'Ви дійсно хочете очистити всі застосовані параметри фільтрації?',
    SetIsPassed: 'Ви хочете провести документ?',
    ClearIsPassed: 'Ви хочете скасувати проведення документа?',
    ChangeFilter: 'Ви дійсно хочете замінити фільтр?',
    ChangeFavorite: 'Ви дійсно хочете прибрати ознаку "Улюблений фільтр"?',
    DeleteFilter: 'Ви дійсно хочете видалити збережений фільтр?',
  },

  Message: {
    EnterLoginAndPass: 'Введіть логін і пароль',
    Deleted: 'Видалено',
    SingIn: 'Увійти в свій аккаунт',
    EnterFilterName: 'Введіть назву фільтра',
    CheckYourEmail: 'Перевірте вашу пошту для закінчення процедури відновлення пароля',
    Count: 'КІЛЬКІСТЬ',
    Avg: 'СР.ЗНАЧЕННЯ',
    Sum: 'СУММА',
    Min: 'МІН',
    Max: 'МАКС',
    FilterAddedToFavorite: 'Фільтр додано до "Улюблених"',
    FilterRemovedFromFavorite: 'Фільтр видалений з "Улюблених"',
    FilterSetAsDefault: 'Фільтр встановлений фільтром за замовчуванням',
    FilterSetAsRegular: 'Фільтр більше не є фільтром за замовчуванням',
    FilterChanged: 'Фільтр змінений',
    FilterRemoved: 'Фільтр видалений',
    FilterNameChanged: 'Назва фільтру змінена',
    WeCanNotFindPage: 'Здається, ми не можемо знайти сторінку, яку ви шукаєте.',
    SomethingWentWrong: 'Щось пішло не так!',
    HereHelpfulLinks: 'Деякі корисні посилання:',
    ErrorCode404: 'Код помилки: 404',
    Help: 'Допомога',
    UserSettings: 'Налаштування користувача',
    Notifications: 'Повідомлення',
    Profile: 'Профіль',
  },

  Controls: {
    Home: 'На головну',
    SingIn: 'Увійти',
    SingOut: 'Вийти',
    SingUp: 'Реєстрація',
    Login: 'Логін',
    ForgotPassword: 'Забули пароль?',
    Name: 'Імʼя',
    Email: 'Пошта',
    Password: 'Пароль',
    Cancel: 'Скасувати',
    Close: 'Закрити',
    Clear: 'Очистити',
    Yes: 'Так',
    No: 'Ні',
    All: 'Усі',
    On: 'Ввімк',
    Off: 'Вимк',
    OK: 'OK',
    OR: 'або',
    Confirmation: 'Підтвердження',
    SelectAll: 'Виділити все',
    Select: 'Вибрати',
    SelectValue: 'Вибрати значення',
    SelectAllHint: 'Виділення усіх рядків таблиці',
    ShowTableFilterRow: 'Показати/Сховати рядок фильтрації',
    UserSettings: 'Налаштування користувача',
    GeneralSettings: 'Загальні налаштування',
    TablesTreesSettings: 'Налаштування таблиць і дерев',
    EditorStylingMode: 'Режим стилів редакторів',
    Filter: 'Фільтр',
    SaveCurrentFilter: 'Зберегти поточний фільтр',
    FilterManager: 'Менеджер фільтрів',
    CopyFilterAsURL: 'Скопіювати фільтр як посилання',
    ChangeFilter: 'Змінити фільтр',
    LoadAll: 'Завантажити все',
    Report: 'Звіт',
    ReportGroup: 'Група звітів',
    DeselectAll: 'Скасувати виділення всього',
    DeselectAllHint: 'Скасування виділення всіх рядків таблиці',
    LoadingPanel: 'Завантаження...',
    SaveAndClose: 'Зберігти и закрити',
    Apply: 'Застосувати',
    RegionalSettings: 'Регіональні налаштування',
    CommonSettings: 'Загальні',
    ResetAllSettings: 'Скинути всі налаштування',
    ColumnChooser: 'Вибір колонок',
    Settings: 'Налаштування',
    CalcTotals: 'Підсумковий рядок',
    CalcTotalsNone: 'Відключено',
    CalcTotalsNoneHint: 'Розрахунок підсумкового рядка відключено',
    CalcTotalsBySelected: 'По виділенним',
    CalcTotalsBySelectedHint: 'Розрахувати підсумковий рядок по обраним записам',
    CalcTotalsAllData: 'По всім данним',
    TabSettings: 'Налаштування закладок',
    ResetAllSettingsHint: 'Скинути налаштування користувача',
    Add: 'Додати',
    Edit: 'Редагувати',
    View: 'Перегляд',
    Delete: 'Видалити',
    Copy: 'Скопіювати',
    Refresh: 'Оновити',
    IsBlank: 'Пусто',
    IsNotBlank: 'Не пусто',
    IsAnyOf: 'Будь-який з',
    IsNotAnyOf: 'Жоден з',
    Preferences: 'Налаштування',
    Export: 'Експорт',
    ExportAll: 'Експорт всіх даних',
    ExportSelected: 'Експорт обраних записів',
    Rename: 'Перейменувати',
    SaveWithOutClose: 'Зберегти без закриття',
    Save: 'Зберегти',
    Discard: 'Скасувати',
    Send: 'Відправити',
    SendRequest: 'Відправити запит',
    ApplicationLanguage: 'Мова додатку',
    Appearance: 'Зовнішній вигляд',
    ApplicationTheme: 'Тема додатку',
    DrawerTheme: 'Тема панелі навігації',
    SystemToolbarTheme: 'Тема системної панелі',
    ApplicationDrawerSide: 'Положення меню',
    DrawerSideLeft: 'Зліва',
    DrawerSideRight: 'Справа',
    Format: 'Формат',
    ClearQuickFilters: 'Очистити всі змінені параметри фільтрації',
    ClearAll: 'Очистити все',
    RememberMe: "Запам'ятати мене",
    SetIsPassed: 'Провести документ',
    ClearIsPassed: 'Скасувати проведення документа',
    AddChild: 'Додати дочірній запис',
    ShowMore: 'Показати більше',
    ShowTitle: 'Показувати текст',
    More: 'Ще',
    OpenInNewTab: 'Відкрити в новій вкладці',
    Toolbar: 'Тулбар',
    Menu: 'Меню',
    Open: 'Відкрити',
    CopyText: 'Скопіювати текст',
    Blank: '(Порожньо)',
    Today: 'Сьогодні',
    StartWork: 'Початок роботи',
    CreateProject: 'Створення проектів',
    Orders: 'Робота с замовленнями',
    Groups: 'Групи',
    CreateList: 'Створення списків',
    Filters: 'Робота з фільтрами',
    EditFilters: 'Редагування фільтрів',
    Documentation: 'Вся документація',
    ProfileSettings: 'Налаштування профілю',
    GoBack: 'Назад',
    GoToMenu: 'Повернутися в меню',
    HideColumn: 'Сховати колонку',
    UnfixColumns: 'Відкріпити колонки',
    SortAscending: 'Сортування за зростанням',
    SortDescending: 'Сортування за спаданням',
    ClearSorting: 'Очистити сортування',
    ClearFiltering: 'Очистити фільтр',
    Unfix: 'Відкріпити',
    FixColumnsToTheLeft: 'Закріпити все вліво',
    FixToTheLeft: 'Закріпити вліво',
    FixToTheRight: 'Закріпити вправо',
    DefaultFilter: 'Фільтр за замовчуванням',
    Favorite: 'В обрані',
    ModifyDate: 'Дата редагування',
    NewFilter: 'Новый фільтр',
    ShowFilterDockPanel: 'Показати панель фільтрації',
    ShowEditDockPanel: 'Показати панель редагування',
    CustomizeFields: 'Налаштувати поля',
    ShowFields: 'Показувати поля',
    Default: 'Стандартні',
    SavedFilters: 'Збережені фільтри',
    SmallRowSize: 'Маленький',
    MediumRowSize: 'Середній',
    LargeRowSize: 'Великий',
    RowSizes: 'Розмір рядків',
    Columns: 'Колонки',
    Tabs: 'Закладки',
    Buttons: 'Кнопки',
    Other: 'Інші',
    Value: 'Значення поля',
    Values: 'Значення полів',
    Search: 'Пошук',
    Sections: 'Розділ',
    Favorites: 'Обране',
    EmptyListText: 'Вибрані фільтри відсутні',
    InterfaceSize: 'Розмір інтерфейсу',
    Language: 'Мова',
    SelectCamera: 'Оберіть камеру',
    Contains: 'Пошук за збiгом',
    StartsWith: 'Пошук за першими символами',
    ByWords: 'Пошук за словами',
    Help: 'Довідка',
    Details: 'Детальніше',
    Equals: 'Дорівнює',
    DoesNotEquals: 'Не дорівнює',
    LessThan: 'Менше ніж',
    GreaterThan: 'Більше ніж',
    LessOrEqualTo: 'Менше або дорівнює',
    GreaterOrEqualTo: 'Більше або дорівнює',
    Between: 'Між',
    ContainsSmth: 'Містить',
    StartsWithSmth: 'Починається',
    ByWordsSearch: 'По словах',
    Boards: 'Дошки',
    AllVisible: 'Всі видимі',
    ClearValueMode: 'Режим очистки значення',
    HorizontalSeparatorLines: 'Горизонтальні розділові лінії',
    VerticalSeparatorLines: 'Вертикальні розділові лінії',
    AlternativeLinesColor: 'Альтернативний колір строк',
    DefaultSt: 'По замовчанню',
    Show: 'Показувати',
    Hide: 'Не показувати',
    PreviewFile: 'Перегляд файлу',
  },
  AdditionalText: {
    YouDontHaveNotifications: 'У вас немає повідомлень',
    UnsavedChanges: 'У вас є незбережені зміни! Ви хочете зберегти або скасувати ці зміни?',
    UseYourAccount: 'або використовуйте Ваш аккаунт',
    EnterYourDetails: 'Введіть ваші персональні дані і почніть подорож з нами',
    NewPassword: 'Новий пароль',
    ToKeepConnected: 'Щоб продовжити роботу, зайдіть під своїми персональними даними',
    WelcomeBack: 'З поверненням!',
    CreateAccount: 'Створити аккаунт',
    RestorePassword: 'Відновити пароль',
    ByDefault: 'За замовчуванням',
    InSubsystem: 'У підсистемі',
    ModifyDate: 'Дата редагування',
    D5: 'D5',
    Insert: 'Створення',
    Edit: 'Редагування',
    View: 'Перегляд',
    ResourceNotFound: 'Ресурс не знайдено',
  },
};

export default Messages;
